import React from 'react';
import Logo from '../../assets/logo.png';
import LogoutIcon from '../../assets/icons/logout.svg';
import { gotoLocation } from '../../utils';

const Header = () => {
    return (
        <nav className='navbar flex justifyBetween alignCenter'>
            <div
                className=' flex justiftStart alignCenter'
                onClick={() => gotoLocation('dashboard/applicants')}
            >
                <img className='logo' src={Logo} alt='Logo' />
                <h2 className='header_title'>جامعہ نظامیہ رضویہ ،پاکستان</h2>
            </div>
            <div
                className='flex justifyCenter alignCenter'
                style={{ marginTop: 8 }}
                onClick={() => {
                    window.localStorage.clear();
                    gotoLocation('login')
                }}
            >
                <img src={LogoutIcon} alt='logout' height={24} width={24} />
                <h4 className='logout_button'>سسٹم سے باہر جائیں</h4>
            </div>
        </nav>
    );
};

export default Header;
